module.exports = __webpack_public_path__ + "img/Pack_remise.deee7d12.jpeg";